import { render, staticRenderFns } from "./switch_to_ios_app.vue?vue&type=template&id=17828476&"
import script from "./switch_to_ios_app.vue?vue&type=script&lang=js&"
export * from "./switch_to_ios_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports